import React from "react";
import { Link } from "react-router-dom";
import reportData from "../config/reports.json";

// ✅ Same slugify logic used in PowerBIEmbed.jsx
const slugify = (str) =>
  decodeURIComponent(str)
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, "")
    .trim()
    .replace(/\s+/g, "-");

const ReportLinks = () => {
  return (
    <div style={{ padding: "1rem" }}>
      {reportData.map((dashboard, index) => (
        <div key={`${slugify(dashboard.dashboard)}-${slugify(dashboard.report)}-${index}`} style={{ marginBottom: "1rem" }}>
          <h3>{dashboard.dashboard} - {dashboard.report}</h3>
          <ul>
            {dashboard.pages.map((page, pIndex) => {
              const route = `/${slugify(dashboard.dashboard)}/${slugify(dashboard.report)}/${slugify(page.name)}`;
              return (
                <li key={`${slugify(page.name)}-${pIndex}`}>
                  <Link to={route}>{page.name}</Link>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default ReportLinks;
